import { ShoppingCart } from "@mui/icons-material";
import Button from "e.sic-platform.webclient/src/components/button/Button";
import useThemeService from "e.sic-platform.webclient/src/services/theme-service/ThemeService";

export default function CheckoutButton(props:{onClick: () => void, disabled?: boolean}) {
  const { themeClass } = useThemeService();

  return (
    <Button
        id="checkout-button"
        onClick={props.onClick}
        disabled={props.disabled}
        icon={{
          svg: ShoppingCart,
          textKey: "shop.checkout",
          className: themeClass(["icon-custom"]),
        }}
        className={themeClass(["btn-huge", "run-ai-button"])}
      />
  )
}
